import * as actions from './teamList/actions'
import * as mutations from './teamList/mutations'
import * as getters from './teamList/getters'

import { dataProps } from './teamList/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/teamList.js